import { formatPriceOrDash } from '../../Utils/priceSimulationUtils';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';
import type { DisplayProduct } from './PriceSimulation.types';

const PackageStructureProductRow = ({ product }: { product: DisplayProduct }) => {
    return (
        <div className="d-flex justify-content-between align-items-center py-8 pl-24">
            <span className="d-flex align-items-center gap-8">
                <SpirisIcon name="tag" />
                {product.name}
            </span>
            <span className="text-secondary">{formatPriceOrDash(product.price)}</span>
        </div>
    );
};

export default PackageStructureProductRow;
